import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const LevelAccessContext = createContext(null);

export const LevelAccessProvider = ({ children }) => {
  const { user, updateUser } = useAuth();

  // Derive from live user object so it stays in sync after unlocks
  const unlockedLevels  = user?.unlockedLevels  || user?.student?.unlockedLevels  || ['A1'];
  const completedLevels = user?.completedLevels || user?.student?.completedLevels || [];
  const currentLevel    = user?.currentLevel    || user?.student?.currentLevel    || 'A1';

  const isLevelUnlocked  = (level) => unlockedLevels.includes(level);
  const isLevelCompleted = (level) => completedLevels.includes(level);

  const getLevelStatus = (level) => {
    if (isLevelCompleted(level)) return 'completed';
    if (isLevelUnlocked(level))  return 'active';
    return 'locked';
  };

  // Called after a successful admin unlock so the UI reflects instantly
  const unlockLevel = (level) => {
    const next = [...new Set([...unlockedLevels, level])];
    updateUser({
      unlockedLevels: next,
      currentLevel: level,
      student: { ...user?.student, unlockedLevels: next, currentLevel: level },
    });
  };

  return (
    <LevelAccessContext.Provider value={{
      unlockedLevels,
      completedLevels,
      currentLevel,
      isLevelUnlocked,
      isLevelCompleted,
      getLevelStatus,
      unlockLevel,
    }}>
      {children}
    </LevelAccessContext.Provider>
  );
};

export const useLevelAccess = () => {
  const ctx = useContext(LevelAccessContext);
  if (!ctx) throw new Error('useLevelAccess must be used within LevelAccessProvider');
  return ctx;
};
